// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TasksView {
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 46px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
}

.TasksView_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.TasksView_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.TasksView_title {
    font-weight: 600;
    font-size: calc(20px * var(--fontScaler));
    line-height: 27px;
    color: #000000;
}

.TasksView_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.TasksView_filter_icon:hover {
    opacity: 1;
}

.TasksView_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.TasksView_filter_icon--active:hover {
    opacity: 1;
}

.TasksView_header_actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.TasksView_addWrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.TasksView_addWrapper:hover {
    opacity: 1;
}

.TasksView_addIcon {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.TasksView_addText {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    white-space: nowrap;
}

.TasksView_main {
    flex: 1;
    overflow: auto;
}

.TasksView_loading,
.TasksView_empty,
.TasksView_error {
    text-align: center;
    padding: 40px 20px;
    font-size: calc(16px * var(--fontScaler));
    color: #8E9ABB;
}

.TasksView_error {
    color: #E23424;
}

.TasksView_list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 4px;
}

.TasksView_task {
    background: #FFFFFF;
    box-shadow: 0px 2px 8px rgba(202, 196, 208, 0.35);
    border-radius: 16px;
    padding: 16px 20px;
    position: relative;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.TasksView_task--checked {
    opacity: 0.6;
}

.TasksView_task_checkbox {
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 2px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 2px;
}

.TasksView_task_checkbox:hover {
    border-color: #f90;
}

.TasksView_task_checkbox--checked {
    background-color: #f90;
    border-color: #f90;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
}

.TasksView_task_title--checked {
    text-decoration: line-through;
    opacity: 0.7;
}

.TasksView_task:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(202, 196, 208, 0.45);
}

.TasksView_task_content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.TasksView_task_header {
    display: flex;
    align-items: baseline;
    gap: 12px;
    flex-wrap: wrap;
}

.TasksView_task_title {
    font-weight: 600;
    font-size: calc(16px * var(--fontScaler));
    line-height: 22px;
    color: #000000;
}

.TasksView_task_date {
    font-size: calc(13px * var(--fontScaler));
    line-height: 22px;
    color: #86868B;
    font-weight: 400;
}

.TasksView_task_tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
}

.TasksView_task_tag {
    background: #F3F6FF;
    border: 1px solid #E2E9FC;
    border-radius: 8px;
    padding: 3px 10px;
    font-size: calc(11px * var(--fontScaler));
    color: #5B6B9A;
    font-weight: 500;
}

.TaskEditModal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.TaskEditModal {
    background: #FFFFFF;
    border-radius: 16px;
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
}

.TaskEditModal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #E0E4E7;
}

.TaskEditModal_title {
    font-weight: 600;
    font-size: calc(18px * var(--fontScaler));
    color: #000000;
}

.TaskEditModal_close {
    background: none;
    border: none;
    font-size: 28px;
    color: #8E9ABB;
    cursor: pointer;
    line-height: 1;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.TaskEditModal_close:hover {
    color: #000000;
}

.TaskEditModal_content {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
}

.TaskEditModal_field {
    margin-bottom: 20px;
}

.TaskEditModal_label {
    display: block;
    font-weight: 500;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
    margin-bottom: 8px;
}

.TaskEditModal_input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #E0E4E7;
    border-radius: 8px;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
    outline: none;
    transition: border-color 0.2s;
}

.TaskEditModal_input:focus {
    border-color: #FFA825;
}

.TaskEditModal_textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #E0E4E7;
    border-radius: 8px;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
    outline: none;
    transition: border-color 0.2s;
    resize: vertical;
    min-height: 60px;
    font-family: inherit;
}

.TaskEditModal_textarea:focus {
    border-color: #FFA825;
}

.TaskEditModal_checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
}

.TaskEditModal_checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.TaskEditModal_tagInput {
    display: flex;
    gap: 8px;
}

.TaskEditModal_addTagButton {
    background: #FFA825;
    color: #FFFFFF;
    border: none;
    border-radius: 8px;
    width: 40px;
    height: 40px;
    font-size: 20px;
    cursor: pointer;
    flex-shrink: 0;
}

.TaskEditModal_addTagButton:hover {
    background: #E8941F;
}

.TaskEditModal_tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 12px;
}

.TaskEditModal_tag {
    background: #F3F6FF;
    border: 1px solid #E2E9FC;
    border-radius: 12px;
    padding: 6px 12px;
    font-size: calc(13px * var(--fontScaler));
    color: #5B6B9A;
    display: flex;
    align-items: center;
    gap: 6px;
}

.TaskEditModal_tagRemove {
    background: none;
    border: none;
    color: #8E9ABB;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.TaskEditModal_tagRemove:hover {
    color: #E23424;
}

.TaskEditModal_footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid #E0E4E7;
}

.TaskEditModal_button {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: calc(14px * var(--fontScaler));
    font-weight: 500;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s;
}

.TaskEditModal_button--secondary {
    background: #F3F6FF;
    color: #5B6B9A;
}

.TaskEditModal_button--secondary:hover {
    background: #E2E9FC;
}

.TaskEditModal_button--primary {
    background: #FFA825;
    color: #FFFFFF;
}

.TaskEditModal_button--primary:hover {
    background: #E8941F;
}

.TaskEditModal_button--delete {
    background: transparent;
    padding: 10px 12px;
    margin-left: auto;
    transition: background-color 0.2s;
}

.TaskEditModal_button--delete:hover {
    background: #F5F5F7;
}

.TaskEditModal_delete_icon {
    display: block;
    width: 18px;
    height: 18px;
    opacity: 0.6;
    transition: opacity 0.2s;
}

.TaskEditModal_button--delete:hover .TaskEditModal_delete_icon {
    opacity: 1;
}

.TasksView_task_description_wrapper {
    margin-top: 4px;
}

.TasksView_task_description {
    font-size: calc(14px * var(--fontScaler));
    line-height: 20px;
    color: #666666;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.TasksView_task_description.collapsed {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.TasksView_task_description.expanded {
    display: block;
}

.TasksView_task_toggle {
    background: transparent;
    border: none;
    color: #007AFF;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 500;
    cursor: pointer;
    padding: 4px 0;
    margin-top: 4px;
    transition: opacity 0.2s;
}

.TasksView_task_toggle:hover {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/tasks/TasksView.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yDAAwL;IACxL,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yCAAyC;IACzC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".TasksView {\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 46px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n    display: flex;\n    flex-direction: column;\n}\n\n.TasksView_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-shrink: 0;\n}\n\n.TasksView_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.TasksView_title {\n    font-weight: 600;\n    font-size: calc(20px * var(--fontScaler));\n    line-height: 27px;\n    color: #000000;\n}\n\n.TasksView_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.TasksView_filter_icon:hover {\n    opacity: 1;\n}\n\n.TasksView_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.TasksView_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.TasksView_header_actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.TasksView_addWrapper {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.TasksView_addWrapper:hover {\n    opacity: 1;\n}\n\n.TasksView_addIcon {\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.TasksView_addText {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    white-space: nowrap;\n}\n\n.TasksView_main {\n    flex: 1;\n    overflow: auto;\n}\n\n.TasksView_loading,\n.TasksView_empty,\n.TasksView_error {\n    text-align: center;\n    padding: 40px 20px;\n    font-size: calc(16px * var(--fontScaler));\n    color: #8E9ABB;\n}\n\n.TasksView_error {\n    color: #E23424;\n}\n\n.TasksView_list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 4px;\n}\n\n.TasksView_task {\n    background: #FFFFFF;\n    box-shadow: 0px 2px 8px rgba(202, 196, 208, 0.35);\n    border-radius: 16px;\n    padding: 16px 20px;\n    position: relative;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.TasksView_task--checked {\n    opacity: 0.6;\n}\n\n.TasksView_task_checkbox {\n    width: 20px;\n    height: 20px;\n    min-width: 20px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: 2px;\n}\n\n.TasksView_task_checkbox:hover {\n    border-color: #f90;\n}\n\n.TasksView_task_checkbox--checked {\n    background-color: #f90;\n    border-color: #f90;\n    background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/></svg>');\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.TasksView_task_title--checked {\n    text-decoration: line-through;\n    opacity: 0.7;\n}\n\n.TasksView_task:hover {\n    transform: translateY(-2px);\n    box-shadow: 0px 4px 12px rgba(202, 196, 208, 0.45);\n}\n\n.TasksView_task_content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.TasksView_task_header {\n    display: flex;\n    align-items: baseline;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.TasksView_task_title {\n    font-weight: 600;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 22px;\n    color: #000000;\n}\n\n.TasksView_task_date {\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 22px;\n    color: #86868B;\n    font-weight: 400;\n}\n\n.TasksView_task_tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 4px;\n}\n\n.TasksView_task_tag {\n    background: #F3F6FF;\n    border: 1px solid #E2E9FC;\n    border-radius: 8px;\n    padding: 3px 10px;\n    font-size: calc(11px * var(--fontScaler));\n    color: #5B6B9A;\n    font-weight: 500;\n}\n\n.TaskEditModal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.TaskEditModal {\n    background: #FFFFFF;\n    border-radius: 16px;\n    width: 90%;\n    max-width: 500px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.TaskEditModal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #E0E4E7;\n}\n\n.TaskEditModal_title {\n    font-weight: 600;\n    font-size: calc(18px * var(--fontScaler));\n    color: #000000;\n}\n\n.TaskEditModal_close {\n    background: none;\n    border: none;\n    font-size: 28px;\n    color: #8E9ABB;\n    cursor: pointer;\n    line-height: 1;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.TaskEditModal_close:hover {\n    color: #000000;\n}\n\n.TaskEditModal_content {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.TaskEditModal_field {\n    margin-bottom: 20px;\n}\n\n.TaskEditModal_label {\n    display: block;\n    font-weight: 500;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n    margin-bottom: 8px;\n}\n\n.TaskEditModal_input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #E0E4E7;\n    border-radius: 8px;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.TaskEditModal_input:focus {\n    border-color: #FFA825;\n}\n\n.TaskEditModal_textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #E0E4E7;\n    border-radius: 8px;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n    outline: none;\n    transition: border-color 0.2s;\n    resize: vertical;\n    min-height: 60px;\n    font-family: inherit;\n}\n\n.TaskEditModal_textarea:focus {\n    border-color: #FFA825;\n}\n\n.TaskEditModal_checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n}\n\n.TaskEditModal_checkbox input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n.TaskEditModal_tagInput {\n    display: flex;\n    gap: 8px;\n}\n\n.TaskEditModal_addTagButton {\n    background: #FFA825;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 8px;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.TaskEditModal_addTagButton:hover {\n    background: #E8941F;\n}\n\n.TaskEditModal_tags {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    margin-top: 12px;\n}\n\n.TaskEditModal_tag {\n    background: #F3F6FF;\n    border: 1px solid #E2E9FC;\n    border-radius: 12px;\n    padding: 6px 12px;\n    font-size: calc(13px * var(--fontScaler));\n    color: #5B6B9A;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.TaskEditModal_tagRemove {\n    background: none;\n    border: none;\n    color: #8E9ABB;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.TaskEditModal_tagRemove:hover {\n    color: #E23424;\n}\n\n.TaskEditModal_footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 20px 24px;\n    border-top: 1px solid #E0E4E7;\n}\n\n.TaskEditModal_button {\n    padding: 10px 24px;\n    border-radius: 8px;\n    font-size: calc(14px * var(--fontScaler));\n    font-weight: 500;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.2s;\n}\n\n.TaskEditModal_button--secondary {\n    background: #F3F6FF;\n    color: #5B6B9A;\n}\n\n.TaskEditModal_button--secondary:hover {\n    background: #E2E9FC;\n}\n\n.TaskEditModal_button--primary {\n    background: #FFA825;\n    color: #FFFFFF;\n}\n\n.TaskEditModal_button--primary:hover {\n    background: #E8941F;\n}\n\n.TaskEditModal_button--delete {\n    background: transparent;\n    padding: 10px 12px;\n    margin-left: auto;\n    transition: background-color 0.2s;\n}\n\n.TaskEditModal_button--delete:hover {\n    background: #F5F5F7;\n}\n\n.TaskEditModal_delete_icon {\n    display: block;\n    width: 18px;\n    height: 18px;\n    opacity: 0.6;\n    transition: opacity 0.2s;\n}\n\n.TaskEditModal_button--delete:hover .TaskEditModal_delete_icon {\n    opacity: 1;\n}\n\n.TasksView_task_description_wrapper {\n    margin-top: 4px;\n}\n\n.TasksView_task_description {\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 20px;\n    color: #666666;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n}\n\n.TasksView_task_description.collapsed {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.TasksView_task_description.expanded {\n    display: block;\n}\n\n.TasksView_task_toggle {\n    background: transparent;\n    border: none;\n    color: #007AFF;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 500;\n    cursor: pointer;\n    padding: 4px 0;\n    margin-top: 4px;\n    transition: opacity 0.2s;\n}\n\n.TasksView_task_toggle:hover {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
